import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
  delete_icon,
  edit_icon,
  eye_icon,
  green_icon,
  password_icon,
  red_icon,
  toggle_off,
  toggle_on,
  view_icon,
} from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { admin_list } from "../redux/api/dummyJson";
import CancelIcon from "@mui/icons-material/Cancel";
import apiRequest from "../redux/api/apiRequest";
import {
  useAddAdminCompanyMutation,
  useLazyAdminStatusCompanyQuery,
  useDeleteAdminCompanyMutation,
  useLazyViewAdminCompanyQuery,
  useListCompanyAdminMutation,
  useListRoleMutation,
  useUpdateAdminCompanyMutation,
} from "../redux/api/api";
import { EMAIL, PASS } from "../redux/api/Constants";
import { toast } from "react-toastify";
import { get, post } from "../../Services/ApiHandler";
import { URL as ApiCall } from "../../Services/Constant";
import Header from "../../components/Header";

const KnfCompanyAdminList = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const company = JSON.parse(localStorage.getItem("company") ?? "{}");
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const token = localStorage.getItem("token");
  const [deletePopup, setDeletePopup] = useState("");
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const [visible, setVisible] = useState(false);
  const [rolesList, setRoleslist] = useState([]);
  const [rolesLists, setRoleslists] = useState({});
  const [editID, setEditID] = useState("");
  const admindetailsObj = {
    id: "",
    name: "",
    email: "",
    role_id: "",
    knf_role_id: "",
    mobile: "",
    password: "",
    password_confirmation: "",
  };
  const [admindetails, setAdminDetails] = useState(admindetailsObj);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [addAdmin] = useAddAdminCompanyMutation();
  const [viewAdmin] = useLazyViewAdminCompanyQuery();
  const [listAdmin] = useListCompanyAdminMutation();
  const [adminStatus] = useLazyAdminStatusCompanyQuery();
  const [deleteAdmin] = useDeleteAdminCompanyMutation();
  const [updateAdmin] = useUpdateAdminCompanyMutation();
  const [listRole] = useListRoleMutation();

  const [selectedImage, setSelectedImage] = useState();
  const [id, setID] = useState("");
  const [fieldsetEnable, setFiedsetEnable] = useState(true);
  const [emailCheckData, setEmailCheckData] = useState({});
  const [emailCheckFlag, setEmailCheckFlag] = useState(0);

  const handleStatus = async (id) => {
    const res = await apiRequest(adminStatus, id);
    if (res?.status == "success") {
      toast.success(res?.message);
      getList();
    }
  };

  const handleDelete = async () => {
    const res = await apiRequest(deleteAdmin, deletePopup);
    if (res?.status == "success") {
      toast.success(res?.message);
      setDeletePopup("");
      getList();
    }
  };

  const AdminView = async (id, type, data) => {
    setID(data?.id);
    setEditID(data?.id);
    setAdminDetails((prevState) => ({
      ...prevState,
      name: data?.name ? data?.name : "",
      email: data?.email ? data?.email : "",
      role_id: data?.knf_role?.id ? data?.knf_role?.id : "",
      mobile: data?.phone ? data?.phone : "",
      id: data?.id ? data?.id : "",
      is_email_verified: data?.is_email_verified ? data?.is_email_verified : "",
    }));
    setEditMode(1);
    setEmailCheckFlag(1);
    setPopup(type);
  };

  const user_details = JSON.parse(localStorage.getItem("user_details"));

  const getList = async (search) => {
    const formdata = new FormData();
    formdata.append("company_id", user_details?.company_id);
    formdata.append("rows", 10);
    formdata.append("search", search ? search : "");
    formdata.append("order", "desc");
    formdata.append("page", page);
    const res = await apiRequest(listAdmin, formdata);
    if (res?.status == "success") {
      setRoleslists(res?.company_admin);
      setList(res?.users);
      setPagination(res?.pagination_meta);
    }
  };

  const getSuperAdminRolesList = () => {
    post(ApiCall.SUPER_COMPANY_ADMIN_ROLES, {})
      .then((res) => {
        setRoleslist(res?.lists);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
    if (givenpermissions?.includes("CAN-List-ADMINS")) {
      getList();
    }
    // getRolesList();
    getSuperAdminRolesList();
  }, []);

  const AdminAdd = async () => {
    if (
      !admindetails?.name ||
      admindetails?.mobile?.length < 8 ||
      // !admindetails?.email ||
      (!admindetails?.role_id && !admindetails?.knf_role_id)
      // || !admindetails?.email.match(EMAIL)
    ) {
      setError(true);
      return;
    }
    // if (!editMode) {
    //   if (
    //     admindetails?.password?.length < 8 ||
    //     admindetails?.password_confirmation?.length < 8 ||
    //     !admindetails?.password?.match(PASS) ||
    //     admindetails?.password != admindetails?.password_confirmation
    //   ) {
    //     setError(true);
    //     return;
    //   }
    // }
    setError(false);
    const formdata = new FormData();
    formdata.append("company_id", user_details?.company_id);
    formdata.append("name", admindetails?.name);
    formdata.append("email", admindetails?.email);
    if (admindetails?.role_id) {
      formdata.append("knf_role_id", admindetails?.role_id);
    } else {
      formdata.append("knf_role_id", "");
    }

    formdata.append("phone", admindetails?.mobile);
    formdata.append("knf_company", 1);
    formdata.append("knf_type", 1);
    if (admindetails?.password) {
      formdata.append("password", admindetails?.password);
    }
    if (admindetails?.password_confirmation) {
      formdata.append(
        "password_confirmation",
        admindetails?.password_confirmation,
      );
    }
    if (editMode) {
      if (editID) {
        formdata.append("user_id", editID);
      } else {
        formdata.append("user_id", admindetails?.id);
      }
    }
    setLoader(true);
    const res = await apiRequest(editMode ? updateAdmin : addAdmin, formdata);
    setLoader(false);
    if (res?.status == "success") {
      toast.success(res?.message);
      setPopup("");
      setAdminDetails({});
      setEditMode(false);
      setEmailCheckFlag(0);
      setEditID("");
    }
    getList();
  };

  useEffect(() => {
    getList();
  }, [page]);

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    setAdminDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: " Name",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row?.original?.name}</p>;
        },
      },
      {
        Header: " Email",
        accessor: "email",
        Cell: ({ value, row }) => {
          return (
            <div>
              <p>{value}</p>
              <div className="d-flex ac-jc mt-2 gap-2">
                <img
                  src={row?.original?.is_email_verified ? green_icon : red_icon}
                  className="redImg"
                />
                <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  {row?.original?.is_email_verified
                    ? "Verified"
                    : "Not Verified"}
                </p>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Role",
        accessor: "knf_role",
        Cell: ({ value, row }) => {
          return (
            <p>
              {value?.name
                ? value?.name?.includes(`${company?.name} ${"Company Admin"}`)
                  ? value?.name?.replace(company?.name, "")
                  : value?.name
                : "-"}
            </p>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          const isProtectedUser =
            !row.original.knf_role?.role_created_by ||
            rolesLists?.email === row.original.email;

          return (
            <div>
              <button
                onClick={() => {
                  if (
                    givenpermissions?.includes(
                      "CAN-Status-KNF_COMPANY_ADMIN",
                    ) &&
                    !isProtectedUser
                  ) {
                    handleStatus(row.original.id);
                  }
                }}
                className={`border-0 ms-2 cust-btn ${
                  isProtectedUser ||
                  !givenpermissions?.includes("CAN-Status-KNF_COMPANY_ADMIN")
                    ? "opacity-25 pe-none"
                    : ""
                }`}
              >
                {value == 1 ? (
                  <img className="toggle-btn" src={toggle_on} />
                ) : (
                  <img className="toggle-btn" src={toggle_off} />
                )}
              </button>
            </div>
          );
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          const isProtectedUser =
            !row.original.knf_role?.role_created_by ||
            rolesLists?.email === row.original.email;
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {givenpermissions?.includes("CAN-View-KNF_COMPANY_ADMIN") && (
                  <button
                    onClick={() => {
                      navigate("/knf-company-admin-generate", {
                        state: { type: "view", data: row.original },
                      });
                    }}
                    // onClick={() => {
                    //   setPopup("view");
                    //   AdminView(row.original.id, "view", row.original);
                    // }}
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                )}
                {givenpermissions?.includes("CAN-Edit-KNF_COMPANY_ADMIN") && (
                  <button
                    disabled={isProtectedUser}
                    onClick={() => {
                      navigate("/knf-company-admin-generate", {
                        state: { type: "edit", data: row.original },
                      });
                    }}
                    // onClick={() => {
                    //   setPopup("edit");
                    //   AdminView(row.original.id, "edit", row.original);
                    // }}
                    className="cust-btn "
                    className={`cust-btn ${
                      isProtectedUser ? "opacity-50 pe-none" : ""
                    }`}
                  >
                    <img src={edit_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                )}
                {givenpermissions?.includes("CAN-Delete-KNF_COMPANY_ADMIN") &&
                  !isProtectedUser && (
                    <button
                      // onClick={() => setDeletePopup(true)}
                      onClick={() => {
                        setDeletePopup(row.original.id);
                      }}
                      className={`cust-btn`}
                    >
                      <img
                        src={delete_icon}
                        alt=""
                        className={`mx-2 edit-btn `}
                      />
                    </button>
                  )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [rolesLists, page],
  );

  const autoFetchData = (data_new) => {
    let data = {
      ...data_new?.user,
      company: {
        ...data_new?.company,
        site: data_new?.site,
      },
    };
    setFiedsetEnable(false);
    setEmailCheckData(data);
    if (data?.company?.id) {
      setID(data?.company?.id);
    }
    let ob = {
      id: "",
      company_name: "",
      name: "",
      email: "",
      role_id: "",
      mobile: "",
      password: "",
      password_confirmation: "",
      location: "",
      logo: "",
      email_verified: data?.id ? 1 : 0,
      is_email_verified: data?.is_email_verified,
    };

    if (data?.company?.id) {
      setEditMode(true);
    }

    if (data?.company?.logo) {
      setSelectedImage(data?.company?.logo);
    }

    if (data?.company?.name) {
      ob.company_name = data?.company?.name;
    }

    if (data?.company?.site?.address) {
      ob.address = data?.company?.site?.address;
    }
    if (data?.knf_role_id) {
      ob.role_id = data?.knf_role_id;
    }
    if (data?.company?.site?.location) {
      ob.location = data?.company?.site?.location;
    } else if (data?.company?.location) {
      ob.location = data?.company?.location;
    }

    if (data?.phone) {
      ob.mobile = data?.phone;
    }

    if (data?.name) {
      ob.name = data?.name;
    }

    if (data?.company?.logo) {
      ob.logo = data?.company?.logo;
    }

    if (data?.email) {
      ob.email = data?.email;
    } else {
      ob.email = admindetails?.email;
    }

    if (data?.id) {
      ob.id = data?.id;
    }

    setAdminDetails(ob);
  };

  const emailCheck = () => {
    let formdata = new FormData();
    if (admindetails?.email?.length > 0) {
      formdata.append("email", admindetails?.email);
      post("user/" + ApiCall.EMAIL_CHECK, formdata)
        .then((res) => {
          let data = res?.userData?.[0];
          setEmailCheckFlag(1);
          if (res?.userData?.length > 0) {
            if (data?.user?.knf_type == 1) {
              autoFetchData(data);
            } else if (data?.user?.knf_type == null) {
              autoFetchData(data);
            } else {
              toast.error("Email ID already exists");
            }
          } else {
            let ob = {
              ...admindetailsObj,
              email: admindetails.email,
            };

            setEmailCheckData({});
            setAdminDetails(ob);
            if (editID) {
              setEditMode(true);
            }
            toast("please enter all required fields");
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please Enter Valid Email");
    }
  };

  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <Header type={"Admin List"} />
        {givenpermissions?.includes("CAN-Add-KNF_COMPANY_ADMIN") && (
          <button
            onClick={() => {
              navigate("/knf-company-admin-generate");
              // setPopup(true);
            }}
            // onClick={() => setPopup("add")}
            className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn "
          >
            {" "}
            + Add Admin
          </button>
        )}
      </div>

      <div className="d-flex ac-jb mt-2 ">
        <div className="d-flex ac-js">
          <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  mb-0 ">
            Total Count :
          </h4>
          <h4 className="f2 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-0 ms-2">
            {pagination?.total}
          </h4>
        </div>
        <div className="d-flex ac-js">
          <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  me-3 mb-0 ms-3">
            Search
          </h4>
          <input
            type="text"
            className="input-pop ps-2"
            placeholder=" Search"
            onChange={(e) => {
              getList(e.target.value);
            }}
          />
        </div>
      </div>
      {popup && (
        <div className="popup-design">
          <div className="popup">
            <div className="d-flex ac-jb">
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                {popup == "view"
                  ? "View Admin"
                  : popup == "edit"
                    ? "Edit Admin"
                    : "Add Admin"}
              </h2>
              <button
                onClick={() => {
                  if (editMode) {
                    setEditMode(false);
                  }
                  setPopup("");
                  setAdminDetails({});
                  setEmailCheckFlag(0);
                  setEditID("");
                }}
                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
              >
                <CancelIcon />
              </button>
            </div>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 d-flex">
              Email <span className="text-danger">*</span>
            </h4>
            <div className="d-flex">
              <input
                type="email"
                className="input-pop ps-2 w-100"
                placeholder=" Email Address"
                name="email"
                onChange={(e) => {
                  // handleUpdate(e);
                  setEmailCheckFlag(0);
                  setAdminDetails(() => ({
                    ...admindetailsObj,
                    email: e.target.value,
                  }));
                }}
                value={admindetails?.email}
                disabled={popup == "view" ? true : false}
              />
              <button
                className={`email_check_btn ${
                  admindetails?.email?.length > 2 ? "" : "opacity-50"
                }`}
                disabled={
                  admindetails?.email?.length == 0
                    ? true
                    : popup == "view"
                      ? true
                      : false
                }
                onClick={() => emailCheck()}
              >
                Check
              </button>
            </div>
            {id && (
              <div className="d-flex ac-je mt-2 gap-2">
                <img
                  src={admindetails?.is_email_verified ? green_icon : red_icon}
                  className="redImg"
                />
                <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  {admindetails?.is_email_verified
                    ? "Verified"
                    : "Not Verified"}
                </p>
              </div>
            )}
            {emailCheckFlag == 1 && (
              <>
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 d-flex">
                  Name<span className="text-danger">*</span>
                </h4>
                <input
                  type="text"
                  className={`input-pop ps-2 w-100 ${
                    emailCheckFlag == 0 ? "opacity-50" : ""
                  }`}
                  placeholder="Name"
                  name="name"
                  onChange={(e) => {
                    handleUpdate(e);
                  }}
                  value={admindetails?.name}
                  disabled={
                    popup == "view"
                      ? true
                      : emailCheckData?.name
                        ? true
                        : emailCheckFlag == 0
                          ? true
                          : false
                  }
                />
                {error && !admindetails?.name && (
                  <p className="err">Enter Your Name</p>
                )}
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 d-flex">
                  Phone Number (Singapore)<span className="text-danger">*</span>
                </h4>
                <input
                  type="number"
                  className={`input-pop ps-2 w-100 ${
                    emailCheckFlag == 0 ? "opacity-50" : ""
                  }`}
                  placeholder="Phone Number (Singapore)"
                  name="mobile"
                  onChange={(e) => {
                    if (e.target.value?.length <= 8) {
                      handleUpdate(e);
                    }
                  }}
                  value={admindetails?.mobile}
                  disabled={
                    popup == "view"
                      ? true
                      : emailCheckData?.phone
                        ? true
                        : emailCheckFlag == 0
                          ? true
                          : false
                  }
                />
                {error && admindetails?.mobile?.length < 8 && (
                  <p className="err">Enter Valid Phone Number (Singapore)</p>
                )}

                {/* {error &&
                  (!admindetails?.email ||
                    !admindetails?.email.match(EMAIL)) && (
                    <p className="err">Enter Valid Email</p>
                  )} */}
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 d-flex">
                  Roles<span className="text-danger">*</span>
                </h4>
                <select
                  className={`input-pop ps-2 w-100 ${
                    emailCheckFlag == 0 ? "opacity-50" : ""
                  }`}
                  name="role_id"
                  onChange={(e) => {
                    handleUpdate(e);
                  }}
                  value={admindetails?.role_id}
                  disabled={
                    popup == "view"
                      ? true
                      : rolesLists?.email == admindetails?.email
                        ? true
                        : emailCheckData?.knf_role_id
                          ? true
                          : emailCheckFlag == 0
                            ? true
                            : false
                  }
                >
                  <option value={""}> -- Select --</option>
                  {rolesList?.map((item) => {
                    return (
                      // item?.id !== rolesLists?.Knf_role && (
                      <option value={item?.id} key={item?.id}>
                        {item?.name}
                      </option>
                      // )
                    );
                  })}
                </select>
                {error && !admindetails?.role_id && (
                  <p className="err mt-1">Select Your Role</p>
                )}
                {popup != "view" && (
                  <div>
                    {/* <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 d-flex">
                  Password
                  {popup !== "edit" && <span className="text-danger">*</span>}
                </h4>
                <div className="input-pop mb-2 w-100 d-flex ac-jb">
                  <input
                    type={visible ? "text" : "password"}
                    maxLength={20}
                    className="cust-btn  w-90"
                    placeholder="Password"
                    name="password"
                    autoComplete="off"
                    onChange={(e) => {
                      handleUpdate(e);
                    }}
                    value={admindetails?.password}
                  />
                  <img
                    src={eye_icon}
                    onClick={() => setVisible(!visible)}
                    className="eye-icon pointer"
                    alt=""
                  />
                </div>
                {error &&
                  !editMode &&
                  (admindetails?.password?.length < 8 ||
                    !admindetails?.password?.match(PASS)) && (
                    <p className="err">
                      {!admindetails?.password
                        ? "Enter Your password"
                        : !admindetails?.password?.match(PASS)
                          ? "Must include one special char & capital leteer"
                          : "Enter Minimum 8 Charactors"}
                    </p>
                  )}
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 d-flex">
                  Confirm Password{" "}
                  {popup !== "edit" && <span className="text-danger">*</span>}
                </h4>
                <div className="input-pop mb-2 w-100 d-flex ac-jb">
                  <input
                    type={visible ? "text" : "password"}
                    maxLength={20}
                    className="cust-btn w-90"
                    placeholder=" Confirm Password"
                    name="password_confirmation"
                    autoComplete="off"
                    onChange={(e) => {
                      handleUpdate(e);
                    }}
                    value={admindetails?.password_confirmation}
                  />
                  <img
                    src={eye_icon}
                    onClick={() => setVisible(!visible)}
                    className="eye-icon pointer"
                    alt=""
                  />
                </div>
                {error &&
                  !editMode &&
                  (admindetails?.password_confirmation?.length < 8 ||
                    admindetails?.password !=
                      admindetails?.password_confirmation) && (
                    <p className="err">
                      {!admindetails?.password_confirmation
                        ? "Enter Confirm Password"
                        : admindetails?.password_confirmation?.length < 8
                          ? "Enter Minimum 8 Charactors"
                          : "Password Mismatch"}
                    </p>
                  )} */}
                    <div className="d-flex ac-jc">
                      <button
                        onClick={() => {
                          AdminAdd();
                        }}
                        className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                      >
                        {loader && (
                          <div
                            className="spinner-border spinner-border-sm "
                            role="status"
                            style={{ marginRight: "5px" }}
                          ></div>
                        )}
                        Submit
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
      {deletePopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2 mt-1 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setDeletePopup("")} className="no-btn">
                No
              </button>
              <button
                onClick={() => {
                  handleDelete();
                  setDeletePopup(false);
                }}
                className="yes-btn f2"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={true}
      />
    </div>
  );
};

export default KnfCompanyAdminList;
